import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1623 13.4104C20.5624 13.5175 20.8 13.9287 20.6928 14.3289C20.2842 15.8551 19.481 17.2469 18.364 18.3643C17.2469 19.4817 15.8554 20.2853 14.3293 20.6944C12.8032 21.1035 11.1962 21.1036 9.67006 20.6947C8.14388 20.2859 6.75224 19.4824 5.63502 18.3652L3.73535 16.4638V19.6439C3.73535 20.0581 3.39957 20.3939 2.98535 20.3939C2.57114 20.3939 2.23535 20.0581 2.23535 19.6439V14.6519C2.23535 14.2377 2.57114 13.9019 2.98535 13.9019H7.97735C8.39157 13.9019 8.72735 14.2377 8.72735 14.6519C8.72735 15.0661 8.39157 15.4019 7.97735 15.4019H4.79481L6.69568 17.3046C7.62666 18.2355 8.78652 18.9051 10.0582 19.2458C11.33 19.5865 12.6691 19.5865 13.9409 19.2455C15.2127 18.9046 16.3723 18.2349 17.3031 17.3038C18.234 16.3726 18.9034 15.2128 19.2439 13.9409C19.351 13.5408 19.7622 13.3033 20.1623 13.4104Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83853 10.5894C3.43841 10.4823 3.20089 10.0711 3.30801 9.67098C3.71662 8.14474 4.51983 6.75296 5.63688 5.63556C6.75394 4.51816 8.14546 3.71453 9.67158 3.30544C11.1977 2.89635 12.8046 2.89623 14.3308 3.30509C15.857 3.71395 17.2486 4.51738 18.3658 5.63462L20.2655 7.53607V4.35594C20.2655 3.94173 20.6013 3.60594 21.0155 3.60594C21.4297 3.60594 21.7655 3.94173 21.7655 4.35594V9.34794C21.7655 9.76215 21.4297 10.0979 21.0155 10.0979L16.0235 10.0979C15.6093 10.0979 15.2735 9.76215 15.2735 9.34794C15.2735 8.93373 15.6093 8.59794 16.0235 8.59794H19.206L17.3052 6.69527C16.3742 5.76437 15.2143 5.09469 13.9426 4.754C12.6708 4.41328 11.3317 4.41338 10.06 4.75429C8.78819 5.09519 7.62859 5.76489 6.69771 6.69606C5.76683 7.62722 5.09749 8.78704 4.75698 10.0589C4.64986 10.459 4.23866 10.6965 3.83853 10.5894Z"
        fill={colorValue}
      />
    </svg>
  );
};
